/** @type {number} */
let lockCount = 0;

/** @type {number} */
let savedScrollY = 0;

/**
 * Prevents background scroll while overlays (panels, dialogs) are open.
 * Reference-counted so nested overlays restore scroll only when all close.
 */
export function acquireScrollLock() {
  if (lockCount === 0) {
    savedScrollY = window.scrollY;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    document.documentElement.setAttribute('scroll-lock', '');
    document.documentElement.style.setProperty('--scroll-lock-y', `${savedScrollY}px`);
    document.body.style.width = '100%';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollY}px`;

    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
  }

  lockCount++;
}

/**
 * Releases one scroll-lock holder. Restores scroll when the last holder releases.
 */
export function releaseScrollLock() {
  if (lockCount === 0) return;

  lockCount--;

  if (lockCount > 0) return;

  document.documentElement.removeAttribute('scroll-lock');
  document.documentElement.style.removeProperty('--scroll-lock-y');
  document.body.style.width = '';
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.paddingRight = '';
  window.scrollTo({ top: savedScrollY, behavior: 'instant' });
}
